/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Eon snapshot.
*/
export class JobSnapshotDetails {
  /**
  * Snapshot ID.
  */
  'id'?: string;
  /**
  * Date and time of the resource that\'s preserved by the snapshot.
  */
  'pointInTime': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "pointInTime",
      "baseName": "pointInTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return JobSnapshotDetails.attributeTypeMap;
  }

  public constructor() {
  }
}

